<template>
  <ApolloMutation
    :mutation="(gql) => removeCouponMutation"
    :variables="{
      id: orderId,
    }"
    @done="onDone"
  >
    <template #default="{mutate, loading}">
      <ekitabu-button
        class="remove-coupon-btn"
        icon
        x-small
        :disabled="loading"
        :title="$t('checkout.removeCoupon')"
        :ripple="false"
        @click="mutate"
      >
        <spinner-icon
          v-if="loading"
          :size="12"
        />
        <close-icon
          v-else
          :size="12"
        />
      </ekitabu-button>
    </template>
  </ApolloMutation>
</template>

<script>
import CouponMutations from "@/graphql/CouponMutations";
import SpinnerIcon from "@/components/icons/SpinnerIcon.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";

export default {
  name: "RemoveCoupon",
  components: {
    SpinnerIcon,
    CloseIcon,
  },
  props: {
    orderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    removeCouponMutation() {
      return CouponMutations.removeCoupon;
    },
  },
  methods: {
    onDone() {
      this.$emit("cartUpdated");
      this.$emit("snackbarMessage", this.$t('checkout.couponRemoved'));
    },
  },
};
</script>

<style scoped lang="scss">
.remove-coupon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background: none;
  color: $book-grey;
  cursor: pointer;
  padding: 0;
  transition: background 0.12s, color 0.12s;

  &:hover:not(:disabled) {
    background: rgba($book-red, 0.08);
    color: $book-red;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

</style>
